import { onMounted, useContext, useRoute, watch } from '@nuxtjs/composition-api'

export default function useGoTopOnPageChange() {
  const route = useRoute()

  watch(route, (newVal, oldVal) => {
    if (newVal.path.startsWith('/user')) {
      if (oldVal.path.startsWith('/user')) {
        if (getUserCategory(newVal) !== getUserCategory(oldVal)) {
          setTimeout(() => {
            goTop()
          }, 0)
        }
      } else {
        setTimeout(() => {
          goTop()
        }, 0)
      }
    }
  })

  const { from } = useContext()
  onMounted(() => {
    if (from.value && from.value.path !== route.value.path) {
      setTimeout(() => {
        goTop()
      }, 0)
    }
  })

  function goTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  function getUserCategory(route) {
    return '/' + route.path.replace('/user', '').split('/')[1]
  }

  return {}
}
